import { get, isString } from 'lodash';

const getSearchRadius = (distance) => (
  isString(distance) ? distance : get(distance, 'value', '')
);

export default getSearchRadius;
